import { render, staticRenderFns } from "./VtLockToggle.vue?vue&type=template&id=5a95236d&scoped=true&"
import script from "./VtLockToggle.vue?vue&type=script&lang=js&"
export * from "./VtLockToggle.vue?vue&type=script&lang=js&"
import style0 from "./VtLockToggle.vue?vue&type=style&index=0&id=5a95236d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95236d",
  null
  
)

export default component.exports